import { render, staticRenderFns } from "./productSearch.vue?vue&type=template&id=5c3e9fd7&"
import script from "./productSearch.vue?vue&type=script&lang=js&"
export * from "./productSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports